export const LANGUAGES = Object.freeze({
    EN: "en",
    DE: "de",
} as const);

export const DEFAULT_LOCALE = LANGUAGES.DE;
